import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  createTheme,
  IconButton,
  TextField,
  ThemeProvider,
  useTheme,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import {
  Edit,
  Groups2Outlined,
  Info,
  PrintOutlined,
} from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import "moment/locale/id";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import {
  fetchChangeStatusSetoran,
  fetchListSetoran,
} from "state/setoranAction";
import formatRupiah from "utils/formatRupiah";
import FlexBetween from "components/FlexBetween";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import FlexStart from "components/FlexStart";
import { useNavigate } from "react-router-dom";
import { fetchAllListGaji } from "state/gajiAction";
import DetailPenggajianModal from "components/Modals/DetailPenggajianModal";
import CustomFilterModal from "./CustomFilterModal";
import SortableHeader from "components/SortableHeader";
moment.locale("id");

const Penggajian = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openKonfirmasi, setOpenKonfirmasi] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState(
    moment().subtract(1, "months"),
  );
  const [selectedCabang, setSelectedCabang] = useState("all");

  const handleDateChange = (newValue) => {
    setSelectedPeriod(newValue);
    // Jika ingin, kamu bisa handle aksi lain di sini saat tanggal berubah
  };

  const handleCabangChange = (event) => {
    setSelectedCabang(event.target.value);
  };

  const { status, message } = useSelector((state) => state.global);
  const { list_gaji } = useSelector((state) => state.gaji);
  const [filteredData, setFilteredData] = React.useState([]);
  const [appliedFilters, setAppliedFilters] = React.useState({});
  const [openCustomFilter, setOpenCustomFilter] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(30);

  const columnSort = [
    { value: "id_karyawan", label: "ID Karyawan" },
    { value: "nama_karyawan", label: "Nama Karyawan" },
    { value: "jumlah_hadir", label: "Hari Kerja" },
    { value: "total_telat", label: "Total Telat" },
    { value: "potongan_nbh", label: "Potongan NBH" },
    { value: "total_gaji", label: "Total Gaji" },
  ];
  useEffect(() => {
    if (selectedPeriod) {
      const bulan = selectedPeriod.month() + 1; // Januari = 1
      const tahun = selectedPeriod.year();
      dispatch(fetchAllListGaji(bulan, tahun));
    }
  }, [selectedPeriod]);
  useEffect(() => {
    // Apply filters whenever data or filters change
    if (list_gaji) {
      let filtered = applyCustomFilters(list_gaji, appliedFilters);

      // Apply cabang filter
      if (selectedCabang !== "all") {
        filtered = filtered.filter((row) => {
          const cabang = row.nama_cabang;
          if (!cabang) return false;
          return cabang === selectedCabang;
        });
      }

      setFilteredData(filtered);
    }
  }, [list_gaji, appliedFilters, selectedCabang]);
  const handleApplyCustomFilter = (filters) => {
    setAppliedFilters(filters);
  };

  // Main filter logic
  const applyCustomFilters = (data, filterConfig) => {
    if (!filterConfig || Object.keys(filterConfig).length === 0) return data;

    let result = [...data];

    // Apply Search filter (hanya 1 string, tapi cek ke 2 kolom)
    if (filterConfig.search && filterConfig.search.trim() !== "") {
      const searchValue = filterConfig.search.toLowerCase();
      result = result.filter((row) => {
        const idMatch = String(row.id_karyawan || "")
          .toLowerCase()
          .includes(searchValue);
        const namaMatch = String(row.nama_karyawan || "")
          .toLowerCase()
          .includes(searchValue);
        return idMatch || namaMatch;
      });
    }

    // Apply Category filters
    if (filterConfig.filter) {
      if (filterConfig.filter.cabang && filterConfig.filter.cabang.length > 0) {
        result = result.filter((row) => {
          return filterConfig.filter.cabang.includes(row.cabang);
        });
      }

      if (
        filterConfig.filter.nama_cabang &&
        filterConfig.filter.nama_cabang.length > 0
      ) {
        result = result.filter((row) => {
          return filterConfig.filter.nama_cabang.includes(row.nama_cabang);
        });
      }
    }

    // Apply Sort
    if (filterConfig.sort && filterConfig.sort.length > 0) {
      result.sort((a, b) => {
        for (let sortRule of filterConfig.sort) {
          let { column, order } = sortRule;
          let aValue = a[column];
          let bValue = b[column];

          if (aValue == null) return 1;
          if (bValue == null) return -1;

          if (typeof aValue === "string") aValue = aValue.toLowerCase();
          if (typeof bValue === "string") bValue = bValue.toLowerCase();

          if (aValue < bValue) return order === "asc" ? -1 : 1;
          if (aValue > bValue) return order === "asc" ? 1 : -1;
        }
        return 0;
      });
    }

    return result;
  };

  const handleClearCustomFilter = () => {
    setAppliedFilters({});
    setFilteredData([]);
  };

  // Count active filters
  const getActiveFilterCount = () => {
    let count = 0;

    // ✅ Search
    if (appliedFilters.search && appliedFilters.search.trim() !== "") {
      count++;
    }

    // ✅ Date Range
    if (appliedFilters.dateRange) {
      if (
        appliedFilters.dateRange.tanggalAwal ||
        appliedFilters.dateRange.tanggalAkhir
      ) {
        count++;
      }
    }

    // ✅ Filter
    if (appliedFilters.filter) {
      if (appliedFilters.filter.cabang?.length > 0) count++;
      if (appliedFilters.filter.nama_cabang?.length > 0) count++;
    }

    // ✅ Sort (multiple)
    if (
      Array.isArray(appliedFilters.sort) &&
      appliedFilters.sort.some(
        (item) => item.column && item.column.trim() !== "",
      )
    ) {
      count++;
    }

    return count;
  };

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListSetoran());
  };

  const handleSelectedData = (id) => {
    let currentSelectedData = list_gaji.find((item) => item.id === id);
    setSelectedData(currentSelectedData);
  };

  const handleSetujui = () => {
    dispatch(fetchChangeStatusSetoran(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };
  const openLaporanGaji = () => {
    const payslipWindow = window.open("/laporan-gaji", "_blank");
    if (payslipWindow) payslipWindow.focus();
  };
  const openSlipGaji = () => {
    const payslipWindow = window.open("/slip-gaji", "_blank");
    if (payslipWindow) payslipWindow.focus();
  };

  const getUniqueCabang = () => {
    if (!list_gaji || list_gaji.length === 0) return [];
    return [
      ...new Set(
        list_gaji
          .map((row) => {
            const cabang = row.nama_cabang;
            if (!cabang) return null;
            return cabang;
          })
          .filter((val) => val),
      ),
    ].sort();
  };

  const columnsSetoran = [
    {
      name: "id", // Kolom UUID
      label: "ID",
      options: {
        display: false, // Disembunyikan dari tampilan tabel
        filter: false,
        sort: false,
      },
    },
    {
      name: "id_karyawan",
      label: "ID",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "nama_karyawan",
      label: "Nama",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },

    {
      name: "nama_cabang",
      label: "Cabang",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "jumlah_hadir",
      label: "HK",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => value + " Hari",
      },
    },
    {
      name: "jumlah_izin",
      label: "HI",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => value + " Hari",
      },
    },
    {
      name: "total_telat",
      label: "Telat",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => value + " Menit",
      },
    },
    {
      name: "gaji_pokok",
      label: "Gaji Pokok",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => formatRupiah(parseFloat(value)),
      },
    },
    {
      name: "rajin",
      label: "Rajin",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => formatRupiah(parseFloat(value)),
      },
    },
    {
      name: "transportasi",
      label: "Transportasi",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => formatRupiah(parseFloat(value)),
      },
    },
    {
      name: "pulsa",
      label: "Pulsa",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => formatRupiah(parseFloat(value)),
      },
    },
    {
      name: "tunjangan_jabatan",
      label: "Jabatan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => formatRupiah(parseFloat(value)),
      },
    },
    {
      name: "uang_makan",
      label: "Makan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => formatRupiah(parseFloat(value)),
      },
    },
    {
      name: "potongan_nbh",
      label: "Pot NBH",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => formatRupiah(parseFloat(value)),
      },
    },
    {
      name: "potongan_tabungan",
      label: "Pot Tabungan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => formatRupiah(parseFloat(value)),
      },
    },
    {
      name: "potongan_pinjaman",
      label: "Pot Pinjaman",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => formatRupiah(parseFloat(value)),
      },
    },
    {
      name: "total_gaji",
      label: "Total Gaji",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => formatRupiah(parseFloat(value)),
      },
    },
    {
      name: "aksi",
      label: "Aksi",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
          />
        ),
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0]; // Ambil ID dari kolom pertama
          return (
            <>
              <IconButton
                color="info"
                onClick={() => {
                  handleSelectedData(id);
                  setOpenDetail(true);
                }}
              >
                <Info />
              </IconButton>
              <IconButton
                color="info"
                onClick={() => {
                  let dataEdit = list_gaji.find((item) => item.id === id);
                  navigate("/editpenggajian", {
                    state: {
                      dataEdit,
                    },
                  });
                }}
              >
                <Edit />
              </IconButton>
              <IconButton
                color="info"
                onClick={() => {
                  sessionStorage.setItem(
                    "dataslipgaji",
                    JSON.stringify(list_gaji.find((item) => item.id === id)),
                  );
                  openSlipGaji();
                }}
              >
                <PrintOutlined />
              </IconButton>
            </>
          );
        },
      },
    },
  ];
  const handlePrintPDF = () => {
    sessionStorage.setItem("datalaporangaji", JSON.stringify(filteredData));
    sessionStorage.setItem("columnsSetoran", JSON.stringify(columnsSetoran));
    sessionStorage.setItem("selectedPeriod", JSON.stringify(selectedPeriod));
    sessionStorage.setItem("selectedCabang", JSON.stringify(selectedCabang));

    openLaporanGaji();
  };

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    filter: false,
    fixedHeader: false,
    fixedSelectColumn: false,
    search: true,
    viewColumns: false,
    responsive: "standard",
    download: false,
    print: false,
    customToolbar: () => {
      return (
        <IconButton onClick={handlePrintPDF}>
          <PrintOutlined />
        </IconButton>
      );
    },
    rowsPerPageOptions: [
      30,
      60,
      filteredData.length > 0 || Object.keys(appliedFilters).length > 0
        ? filteredData.length
        : list_gaji.length,
    ],
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
  };

  const getMuiTheme = () =>
    createTheme({
      components: {
        // Ukuran font untuk isi row
        MuiTableCell: {
          styleOverrides: {
            root: {
              fontSize: "10px", // <-- kecilkan isi row
              padding: "6px",
            },
          },
        },
        // Opsional: tinggi baris agar lebih ringkas
        MuiTableRow: {
          styleOverrides: {
            root: {
              height: "20px",
            },
          },
        },
      },
    });

  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header title="Gaji" subtitle="Daftar Gaji dari setiap karyawan." />

        <Box>
          <Button
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              "&:hover": {
                backgroundColor: theme.palette.secondary.light, // Tetap sama dengan warna awal
              },
            }}
            onClick={() =>
              navigate("/addpenggajian", {
                state: {
                  bulan: selectedPeriod.month() + 1,
                  tahun: selectedPeriod.year(),
                },
              })
            }
          >
            <Groups2Outlined sx={{ mr: "10px" }} />
            Tambah Gaji
          </Button>
        </Box>
      </FlexBetween>
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <ThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            title={
              <FlexStart mb={2} gap={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    sx={{ mt: 2 }}
                    views={["year", "month"]}
                    label="Pilih Bulan dan Tahun"
                    minDate={moment().subtract(5, "years").startOf("month")}
                    maxDate={moment().subtract(1, "month").endOf("month")}
                    value={selectedPeriod}
                    onChange={handleDateChange}
                    renderInput={(params) => (
                      <TextField {...params} helperText={null} />
                    )}
                  />
                </LocalizationProvider>
                <FormControl sx={{ mt: 2, minWidth: 200 }}>
                  <InputLabel id="cabang-filter-label">Cabang</InputLabel>
                  <Select
                    labelId="cabang-filter-label"
                    id="cabang-filter"
                    value={selectedCabang}
                    label="Cabang"
                    onChange={handleCabangChange}
                  >
                    <MenuItem value="all">Semua Cabang</MenuItem>
                    {getUniqueCabang().map((cabang) => (
                      <MenuItem key={cabang} value={cabang}>
                        {cabang}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </FlexStart>
            }
            data={
              filteredData.length > 0 || Object.keys(appliedFilters).length > 0
                ? filteredData
                : list_gaji
            }
            columns={columnsSetoran}
            options={options}
          />
        </ThemeProvider>
        <CustomFilterModal
          open={openCustomFilter}
          onClose={() => setOpenCustomFilter(false)}
          onApplyFilter={handleApplyCustomFilter}
          onClearFilter={handleClearCustomFilter}
          data={list_gaji}
          sortableColumns={columnSort}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
        <KonfirmasiModal
          titleType={"Setujui"}
          subtitleType={"Menyetujui"}
          dataWillProses={"Setoran Ini"}
          open={openKonfirmasi}
          onClose={() => setOpenKonfirmasi(false)}
          onSubmit={() => handleSetujui()}
          textButtonPositif={"Setujui"}
        />
        <DetailPenggajianModal
          dataDetail={selectedData}
          open={openDetail}
          onClose={() => {
            setSelectedData(null);
            setOpenDetail(false);
          }}
        />
      </Box>
    </Box>
  );
};

export default Penggajian;
